import type { BoostTimerFragment } from "@workspace/casino_core/queries/BoostNotificationQuery";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import getDisplayAmount from "@workspace/casino_pages/legacyLayer/shared/utils/getDisplayAmount";

type Props = { boost: BoostTimerFragment; context: WorkerContext };

const Body: FC<Props> = ({ boost, context }) => {
  const currency = boost.currency as CashierCurrency;
  const { moneyIcon: winDisplay } = getDisplayAmount(
    context.currencyConfig,
    boost.winAmount ?? 0,
    currency,
    context.language,
  );
  const { moneyIcon: boostDisplay } = getDisplayAmount(
    context.currencyConfig,
    boost.boostAmount ?? 0,
    currency,
    context.language,
  );

  return (
    <div className="grid gap-8">
      <h5 className="pt-6 font-headline text-2xl text-foreground">
        <Translation
          id="general.congratulations"
          translations={context.translations}
        />
      </h5>
      <div className="grid gap-2">
        <ResultBox
          translateId="casino.boosts.your_win"
          translations={context.translations}
          display={winDisplay}
          secondary
        />
        <hr className="border-border" />
        <ResultBox
          translateId="casino.boosts.boost"
          translations={context.translations}
          display={boostDisplay}
        />
      </div>
    </div>
  );
};

type ResultBoxProps = {
  translateId: string;
  translations: Record<string, string>;
  display: string;
  secondary?: boolean;
};

const ResultBox: FC<ResultBoxProps> = ({
  translateId,
  translations,
  display,
  secondary,
}) => (
  <div
    className={classNames(
      "flex h-16 w-full flex-col items-center justify-center min-w-[128px]",
    )}
  >
    <span className="text-sm uppercase text-muted-foreground">
      <Translation id={translateId} translations={translations} />
    </span>
    <div className="font-headline text-lg font-semibold text-foreground">
      {!secondary && "🚀"}&nbsp;{display}
    </div>
  </div>
);

export default Body;
